/**
 * @module js/desUpdateLibraryService
 */
import _ from 'lodash';

export const getSelectedFileInfo = (fileName, fileNameNoExt, fileExt, formData, data) => {
    return {
        dataToBeRelated: {
            attachFiles: fileName
        },
        fileInputForms: formData,
        isThumbnailSelected: true
    };
};

export const getSelectedLibraryDetails = (vmo, apiOutput) => {
    const { data, dispatch } = vmo;
    const name = _.get(apiOutput, 'cellHeader2');
    const description = _.get(apiOutput, 'cellHeader1');
    data.name.dbValue = name;
    data.name.dispValue = name;
    data.description.dbValue = description;
    data.description.dispValue = description;
    data.name.value = name;
    data.name.uiValue = name;
    data.description.value = description;
    data.description.uiValue = description;
    dispatch({ path: 'data', value: { ...data } });
};

/**
 * This function update n number of view model data property
 *
 * @param {*} viewModel
 * @param {*} VariablesToUpdate
 */
const updateVmoVariables = (viewModel, VariablesToUpdate) => {
    const { data, dispatch } = viewModel;
    for (const property in VariablesToUpdate) {
        data[property] = VariablesToUpdate[property];
    }

    dispatch({ path: 'data', value: { ...data } });
}

export const storeUserData = (vmo, selectedObjects) => {
    const { data, dispatch } = vmo;
    data.selectedUsers = selectedObjects;
    dispatch({ path: 'data', value: { ...data } });
    return {
        selectedAllUsers: selectedObjects
    };
};

export const storeTeamsData = (vmo, selectedObjects) => {
    const { data, dispatch } = vmo;
    data.selectedTeams = selectedObjects;
    dispatch({ path: 'data', value: { ...data } });
    return {
        selectedAllTeams: selectedObjects
    };
};

export const updateloadedLibraryDetails = (vmo, apiOutput) => {
    const { data, dispatch } = vmo;
    const name = apiOutput.data.revision.properties.name;
    data.name.dbValue = name;
    data.name.dispValue = name;
    data.name.value = name;
    data.name.uiValue = name;
    data.name.isEditable = false;
    dispatch({ path: 'data', value: { ...data } });
};

export const setCustomAttribute = () => {
    //customized height attribute set for global sw-row element
    const element = document.getElementById('aw-share-library-user').parentElement.parentElement;
    element.style.height = '100%';
};

export default {
    getSelectedFileInfo,
    getSelectedLibraryDetails,
    updateVmoVariables,
    storeUserData,
    storeTeamsData,
    updateloadedLibraryDetails,
    setCustomAttribute
};
